export const CREATE_SELECTION = 'createSelection';
export const UPDATE_SELECTION = 'updateSelection';
export const DELETE_SELECTION = 'deleteSelection';
export const SET_SELECTED_SELECTION = 'setSelectedSelection';